<!--Options-->
<div class="ItemBorder">
	<div>
		<!--Info-->
		<h4 style="text-align: center">Exporting File Names for:</h4>
		<div class="Grid2Col">
			<label>Mode:</label>
			<p class="InfoText">{{ Mode }}</p>

			<label>School:</label>
			<p class="InfoText">{{ SchoolName }}</p>

			<label *ngIf="SelectedStudentGroup != undefined">Group:</label>
			<p *ngIf="SelectedStudentGroup != undefined" class="InfoText">{{ StudentGroupName }}</p>
		</div>
	</div>

	<div class="TopMargin">
		<!--Columns-->
		<h4 style="text-align: center">Select and Order Columns</h4>
		<div>
			<div cdkDropList cdkDropListOrientation="horizontal" class="ExportColumnsList" (cdkDropListDropped)="onExportColDragDropped($event)">
				<div
					class="ExportColumnBox"
					*ngFor="let exportCol of lstExportColumns"
					cdkDrag
					[style.background-color]="exportCol.Visible == true ? 'White' : '#f2dede'"
				>
					<h4 [style.color]="exportCol.Visible == true ? 'Black' : 'Red'">{{ exportCol.Desc }}</h4>
					<div class="Grid2Col">
						<label [style.color]="exportCol.Visible == true ? 'Black' : 'Red'">Visible</label>
						<input type="checkbox" class="CHK" [(ngModel)]="exportCol.Visible" (ngModelChange)="onVisibleChange()" />
					</div>
				</div>
			</div>
		</div>
	</div>

	<!--Example File-->
	<div class="TopMargin">
		<h4 style="text-align: center">Example File</h4>

		<div class="ExampleFileTable">
			<p-table
				#exampleDT
				[value]="lstExampleData"
				[paginator]="false"
				[(rows)]="ExamplePageRows"
				[(first)]="ExamplePageFirst"
				[showCurrentPageReport]="false"
				[resizableColumns]="false"
				sortMode="multiple"
				styleClass="p-datatable-striped"
				dataKey="ID"
				currentPageReportTemplate="Showing {first} to {last} of {totalRecords} entries"
				[rowsPerPageOptions]="[5, 10, 25, 50]"
			>
				<!--Headers-->
				<ng-template pTemplate="header">
					<!--Column Names-->
					<tr style="height: 4rem">
						<th *ngFor="let col of lstVisibleExportColumns" [pSortableColumn]="col.DataField">
							{{ col.Desc }}<p-sortIcon [field]="col.DataField"></p-sortIcon>
						</th>
					</tr>
				</ng-template>

				<!--Data-->
				<ng-template pTemplate="body" let-ExampleData>
					<tr>
						<td *ngFor="let col of lstVisibleExportColumns" style="font-weight: bold">
							{{ ExampleData[col.DataField] }}
						</td>
					</tr>
				</ng-template>
			</p-table>
		</div>
	</div>

	<!--File Format-->
	<!--Example File-->
	<div class="TopMargin" style="display: grid; justify-content: center">
		<h4 style="text-align: center">File Format</h4>
		<select [disabled]="Processing == true" class="form-control" name="FileTypeID" [(ngModel)]="FileTypeID">
			<option value="" style="display: none"></option>
			<option *ngFor="let o of lstFileType" [ngValue]="o.ID">{{ o.Desc }}</option>
		</select>
	</div>
</div>

<!--Buttons-->
<div class="Buttons">
	<button [disabled]="Processing == true" class="btn btn-success" (click)="onExport()">Export</button>
	<button [disabled]="Processing == true" class="btn btn-warning" style="margin-left: 5px" (click)="onClose()">Close</button>
</div>

<!--Error Message-->
<div class="TopMargin">
	<div name="errorMessage" *ngIf="errorMessage" class="alert alert-danger">{{ errorMessage }}</div>
</div>
